var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26.4962C52 32.2329 50.1375 37.5321 47 41.8314L62.825 57.6666C64.3875 59.2289 64.3875 61.766 62.825 63.3283C61.2625 64.8906 58.725 64.8906 57.1625 63.3283L41.3375 47.4931C37.0375 50.6427 31.7375 52.4924 26 52.4924C11.6375 52.4924 0 40.8566 0 26.4962C0 12.1358 11.6375 0.5 26 0.5C40.3625 0.5 52 12.1358 52 26.4962ZM26 44.4936C28.3638 44.4936 30.7044 44.028 32.8883 43.1236C35.0722 42.2191 37.0565 40.8935 38.7279 39.2222C40.3994 37.551 41.7252 35.567 42.6298 33.3835C43.5344 31.1999 44 28.8596 44 26.4962C44 24.1327 43.5344 21.7924 42.6298 19.6089C41.7252 17.4254 40.3994 15.4413 38.7279 13.7701C37.0565 12.0989 35.0722 10.7732 32.8883 9.8688C30.7044 8.96434 28.3638 8.49883 26 8.49883C23.6362 8.49883 21.2956 8.96434 19.1117 9.8688C16.9278 10.7732 14.9435 12.0989 13.2721 13.7701C11.6006 15.4413 10.2748 17.4254 9.37017 19.6089C8.46558 21.7924 8 24.1327 8 26.4962C8 28.8596 8.46558 31.1999 9.37017 33.3835C10.2748 35.567 11.6006 37.551 13.2721 39.2222C14.9435 40.8935 16.9278 42.2191 19.1117 43.1236C21.2956 44.028 23.6362 44.4936 26 44.4936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.97251db4e227baf2ec43eb15fc62bcf6.svg";
export { ForwardRef as ReactComponent };